// ─── LocationSelector constants ───
export const COLLAPSED_WIDTH = 80;
export const EXPANDED_WIDTH = 208;
export const HOVER_DELAY = 350; // ms before expansion
export const RECENT_COUNT = 3;
export const MANY_LOCATIONS_THRESHOLD = 6;
export const ITEM_HEIGHT = 56;
export const ITEM_GAP = 8;
export const SNAP_UNIT = ITEM_HEIGHT + ITEM_GAP; // 64px per location slot
export const RECENT_STORAGE_KEY = "oneportal_recent_locations";

// ─── Layout route constants ───
// Route prefixes that belong to each menu level (for CONSUMER contexts only).
// Add new prefixes here when adding routes to keep redirect logic in sync.
export const LOCATION_LEVEL_ROUTES = ["/camera", "/hvac", "/access"];

// Exact route paths that are valid at BOTH account and location level.
// Used to exempt these from the account-level redirect even though they
// share a prefix with a LOCATION_LEVEL_ROUTES entry (e.g. "/camera").
// Note: per-camera device routes /camera/:id/settings and /camera/:id/liveView
// are also exempt via an explicit regex in Layout.tsx (isCameraDeviceRouteAtAccountLevel).
export const BOTH_LEVEL_ROUTES = ["/camera", "/camera/events", "/camera/search", "/camera/multicam", "/camera/bulk-edit", "/camera/bulk-edit/review", "/camera/bulk-edit/replace-schedule"];

// Routes that are ONLY valid at account level (My Organization). When the
// user navigates here while a specific location is selected, we clear the
// selection so the LocationSelector and sidebar reflect account-level state.
export const ACCOUNT_LEVEL_ROUTES = [
  "/dashboard",
  "/business-intelligence",
  "/locations",
  "/alerts",
  "/devices",
  "/employees",
  "/reports",
  "/automations",
  "/notifications",
  "/billing",
  "/settings/company",
];

// ─── Layout feature-flag maps ───
export const CAMERA_FLAG_MAP: Record<string, string> = {
  "/camera": "cameras.live",
  "/camera/search": "cameras.ai-search",
  "/camera/events": "cameras.events",
  "/camera/clips": "cameras.clips",
  "/camera/feature-demo": "cameras.feature-demo",
};

export const BILLING_FLAG_MAP: Record<string, string> = {
  "/billing": "billing.dashboard",
  "/billing/subscriptions": "billing.subscriptions",
  "/billing/payment-methods": "billing.payment-methods",
  "/billing/history": "billing.history",
};
